import { render, staticRenderFns } from "./addPlanFundDialog.vue?vue&type=template&id=4bc5b8df"
import script from "./addPlanFundDialog.vue?vue&type=script&lang=js"
export * from "./addPlanFundDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports